import React, {Component} from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import {deleteFilterIterative} from "scenes/Survey/Structure/data/filterIterative/actions";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {FormattedMessage} from "react-intl";
import LaddaButton, {ZOOM_OUT} from "react-ladda";

class ButtonDeleteFilterIterative extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      deleting: false
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.removeFilter = this.removeFilter.bind(this);
  }

  toggleModal() {
    this.setState({modal: !this.state.modal})
  }

  removeFilter() {
    this.setState({deleting: true});

    this.props.deleteFilterIterative(this.props.filter)
      .catch(() => this.setState({deleting: false}));
  }

  render() {
    const modal = <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
      <ModalHeader toggle={this.toggleModal} tag="h2"><FormattedMessage id="filterIterative.buttonDeleteFilterIterative.cardHeader"/></ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <p><FormattedMessage id="filterIterative.buttonDeleteFilterIterative.cardBody"/></p>
      </ModalBody>
      <ModalFooter>
        <div className="direction-group d-flex justify-content-end">
          <div className="direction-right">
            <FormattedMessage id="_.modal.delete.confirmation">{
              (message) => <LaddaButton
                className="btn btn-danger btn-ladda mb-0 ml-3"
                data-style={ZOOM_OUT}
                onClick={this.removeFilter}
                loading={this.state.deleting}
              >
                {message}
              </LaddaButton>
            }</FormattedMessage>
            <FormattedMessage id="_.button.cancel">{
              (message) => <Button color="secondary" className="mb-0 ml-3" onClick={this.toggleModal}>{message}</Button>
            }</FormattedMessage>
          </div>
        </div>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <span onClick={this.toggleModal}><i className="fas fa-times float-right pointer"/></span>
        {modal}
      </React.Fragment>
    )
  }
}

ButtonDeleteFilterIterative.propTypes = {
  filter: PropTypes.object.isRequired
};

export default connect(null, {deleteFilterIterative})(ButtonDeleteFilterIterative);
